<div #target>
  <ng-template appWidget></ng-template>
</div>
